var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgChatBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 1.9375C5.67578 1.9375 0.999994 5.79297 0.999994 10.4688C0.999994 12.5195 1.86132 14.3652 3.29687 15.8418C2.80468 17.9336 1.08203 19.7383 1.08203 19.7793C0.958979 19.8613 0.958979 20.0254 0.999994 20.1484C1.04101 20.2715 1.16406 20.3125 1.32812 20.3125C4.03515 20.3125 6.04492 19.041 7.07031 18.2207C8.42382 18.7129 9.90038 19 11.5 19C17.2832 19 21.959 15.1855 21.959 10.4688C21.959 5.79297 17.2832 1.9375 11.5 1.9375Z",
    fill: "#13C1BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0.9375C7.67575 0.9375 2.99997 4.79297 2.99997 9.46875C2.99997 11.4375 3.77927 13.2422 5.13279 14.6777C4.55857 16.2773 3.28708 17.6719 3.24607 17.6719C2.95896 17.959 2.91794 18.3691 3.04099 18.7383C3.20505 19.1074 3.57419 19.3125 3.98435 19.3125C6.4863 19.3125 8.45505 18.2871 9.68552 17.4258C10.834 17.7949 12.1465 18 13.5 18C19.2832 18 23.959 14.1855 23.959 9.46875C23.959 4.79297 19.2832 0.9375 13.5 0.9375ZM13.5 16.0312C12.3926 16.0312 11.2851 15.8672 10.2597 15.5391L9.31638 15.252L8.53708 15.8262C7.96286 16.2363 7.14255 16.6875 6.15818 17.0156C6.4863 16.5234 6.77341 15.9492 6.97849 15.375L7.42966 14.2266L6.56833 13.3242C5.83005 12.5449 4.96872 11.2324 4.96872 9.46875C4.96872 5.85938 8.78318 2.90625 13.5 2.90625C18.1758 2.90625 22.0312 5.85938 22.0312 9.46875C22.0312 13.1191 18.1758 16.0312 13.5 16.0312Z",
    fill: "#36424E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgChatBubble);
export default __webpack_public_path__ + "static/media/img_chatBubble.2db8107ecf452b5835cb172e79737fb3.svg";
export { ForwardRef as ReactComponent };